<template>
  <component
    :is="type" class="btn-arrow" :to="to"
    :target="target" @click="triggerClick"
  >
    {{ text }}
    <ArrowRight class="arrow" :class="{ noAnimation }" />
  </component>
</template>

<script>
import ArrowRight from '../assets/svg/arrow-right.svg?vue-component';

export default {
  components: { ArrowRight },
  props: {
    type: { type: String, default: 'span', required: false },
    to: { type: [Object, String], default: '', required: false },
    text: { type: String, required: true },
    noAnimation: Boolean,
    target: { type: String, default: '_self', required: false },
  },
  methods: {
    triggerClick() {
      this.$emit('click');
      if (this.type === 'span' && this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>
